"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Mission() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const headlineWords = [{
    text: "Diversity",
    italic: false
  }, {
    text: "is",
    italic: false
  }, {
    text: "our",
    italic: false
  }, {
    text: "strength;",
    italic: true
  }, {
    text: "inclusion",
    italic: false
  }, {
    text: "is",
    italic: false
  }, {
    text: "our",
    italic: false
  }, {
    text: "mission.",
    italic: false
  }];
  const paragraphs = ["Inclusive Voices News was founded on a single conviction: that unbiased, accessible journalism is the bedrock of a healthy society. We exist to amplify the stories that shape our communities, ensuring that underrepresented voices are not just heard, but centered in the national conversation.", "Our mission is to deliver truth without compromise. We provide a platform for diverse perspectives, rigorous reporting, and multimedia storytelling that challenges the status quo. We believe that information should be a public good, structured for clarity and built for everyone.", "Our approach is deliberate and community-driven. Every article, broadcast, and digital feature is crafted to foster understanding and engagement. We invite you to join us in building a more informed, inclusive, and connected future for all."];
  return <section data-section-id="19375" id="the-mission" className="bg-background text-foreground py-36 md:py-52">
      <div className="mx-auto max-w-[1440px] px-6 md:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-16 lg:gap-x-6">
          {}
          <div className="lg:col-span-7">
            <h1 ref={headlineRef} className="font-default text-foreground" style={{
            fontSize: "clamp(2.75rem, 6.5vw, 5.5rem)",
            fontWeight: 800,
            letterSpacing: "-0.04em",
            lineHeight: 0.9
          }}>
              {headlineWords.map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden align-baseline mr-[0.25em]">
                  <span className={`inline-block ${word.italic ? "italic" : ""}`} style={{
                transform: headlineVisible ? "translateY(0)" : "translateY(100%)",
                opacity: headlineVisible ? 1 : 0,
                transition: `transform 400ms cubic-bezier(0.16, 1, 0.3, 1) ${i * 50}ms, opacity 400ms cubic-bezier(0.16, 1, 0.3, 1) ${i * 50}ms`,
                willChange: "transform, opacity"
              }}>
                    {word.text}
                  </span>
                </span>)}
            </h1>
          </div>

          {}
          <div ref={rightRef} className="lg:col-span-5 lg:col-start-8">
            {}
            <div className="h-px w-full bg-foreground" />

            <div className="pt-6 space-y-6">
              {paragraphs.map((para, i) => <div key={i} data-index={i} style={{
              transform: rightVisible ? "translateY(0)" : "translateY(20px)",
              opacity: rightVisible ? 1 : 0,
              transition: `transform 400ms cubic-bezier(0.16, 1, 0.3, 1) ${400 + i * 50}ms, opacity 400ms cubic-bezier(0.16, 1, 0.3, 1) ${400 + i * 50}ms`,
              willChange: "transform, opacity"
            }}>
                  <p className="font-default text-foreground" style={{
                fontSize: "clamp(1.0625rem, 1.3vw, 1.25rem)",
                fontWeight: 400,
                letterSpacing: "0",
                lineHeight: 1.6
              }}>
                    {para}
                  </p>
                  {i < paragraphs.length - 1 && <div className="mt-6 h-px w-full sm:w-2/5 bg-border" />}
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}